import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { css } from 'glamor';
import { defaultPropsDecorator } from 'substyle';
export var decorateAsDataAttributes = function decorateAsDataAttributes(props) {
  var _defaultPropsDecorato = defaultPropsDecorator(props),
      style = _defaultPropsDecorato.style,
      className = _defaultPropsDecorato.className;

  return _objectSpread(_objectSpread({}, css(style)), {}, {
    className: className
  });
};
export var decorateAsClasses = function decorateAsClasses(props) {
  var _defaultPropsDecorato2 = defaultPropsDecorator(props),
      style = _defaultPropsDecorato2.style,
      className = _defaultPropsDecorato2.className;

  return {
    className: className ? "".concat(className, " ").concat(css(style)) : "".concat(css(style))
  };
};